'use es6';

import { useCallback } from 'react';
import PropTypes from 'prop-types';
import { View } from 'foundations-components/components/View';
import MenuNode from './MenuNode';
import MenuTree from './MenuTree';
import { MENU_TREE_INDENTATION } from '../../constants/menus';
import { jsx as _jsx } from "react/jsx-runtime";
function MenuRoot({
  readOnly,
  menuId,
  parentId,
  nodes,
  maxDepth,
  moveNode
}) {
  const getMenuComponent = useCallback(isNode => {
    return isNode ? MenuTree : MenuNode;
  }, []);
  return /*#__PURE__*/_jsx(View, {
    minInlineSize: `${maxDepth * MENU_TREE_INDENTATION + 650}px`,
    children: /*#__PURE__*/_jsx(MenuTree, {
      parentId: parentId,
      nodes: nodes,
      getMenuComponent: getMenuComponent,
      moveNode: moveNode,
      depth: 0,
      menuId: menuId,
      readOnly: readOnly
    })
  });
}
MenuRoot.propTypes = {
  readOnly: PropTypes.bool,
  menuId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  parentId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  nodes: PropTypes.arrayOf(PropTypes.object),
  maxDepth: PropTypes.number.isRequired,
  moveNode: PropTypes.func.isRequired
};
export default MenuRoot;